module.exports = __webpack_public_path__ + "static/media/14.95f0987f.jpg";